import React, { memo, useEffect } from 'react'
import {
  experimentalStyled,
  Container,
  Box,
  Toolbar,
  Grid,
  Stack
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link, Routes, BrowserRouter, Route } from 'react-router-dom'
import { HashLink } from 'react-router-hash-link'
import { useSwitchChain } from 'wagmi'

import CommunitySaleContainer from './containers/CommunitySaleContainer'
import { CONTAINER_MIN_HEIGHT } from './styles/common'
import WalletConnectButtonWrapper from './components/walletConnect/WalletConnectButtonWrapper'
import qbFoundationLogo from './assets/logos/qiibee-foundation-logo.png'
import HeaderLinkText from './components/shared/text/HeaderLinkText'
import { getChain } from './components/walletConnect/wagmiConfig'
import FooterLinks from './components/layout/FooterLinks'

const App = () => {
  const { t } = useTranslation()
  const { switchChain } = useSwitchChain()
  useEffect(() => {
    switchChain({ chainId: getChain().id })
  }, [])

  return (
    <BrowserRouter>
      <MainWrapper>
        <PageWrapper>
          <Container maxWidth={false}>
            <Toolbar sx={{ mb: { md: 3, xs: 1 }, mt: 2 }} disableGutters>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={6}>
                  <Box
                    sx={{ margin: 'auto' }}
                    textAlign={{ sm: 'left', xs: 'center' }}
                  >
                    <Link to='/'>
                      <img
                        src={qbFoundationLogo}
                        height='43'
                        alt='qiibee Foundation Claim'
                      />
                    </Link>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={6}
                  textAlign={{ sm: 'right', xs: 'center' }}
                >
                  <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={4}
                    alignItems='center'
                    justifyContent='flex-end'
                  >
                    <HeaderLinkText
                      component='a'
                      href='https://qiibeefoundation.org/'
                      label={t('home.go-to-website')}
                      target='_blank'
                      rel='noreferrer'
                    />
                    <HashLink to='#faqs' style={{ textDecoration: 'none' }}>
                      <HeaderLinkText label={t('home.faqs')} />
                    </HashLink>
                    <WalletConnectButtonWrapper t={t} />
                  </Stack>
                </Grid>
              </Grid>
            </Toolbar>
            <Box sx={CONTAINER_MIN_HEIGHT}>
              <Routes>
                <Route path='/' element={<CommunitySaleContainer />} />
              </Routes>
            </Box>
            <FooterLinks t={t} />
          </Container>
        </PageWrapper>
      </MainWrapper>
    </BrowserRouter>
  )
}

export default memo(App)

const MainWrapper = experimentalStyled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  overflow: 'hidden',
  width: '100%'
}))

const PageWrapper = experimentalStyled('div')(({ theme }) => ({
  display: 'flex',
  flex: '1 1 auto',
  overflow: 'hidden',
  backgroundColor: theme.palette.background.default
  // [theme.breakpoints.down('lg')]: {
  //   paddingTop: '70px'
  // }
}))
